<template>
  <div class="row">
    <div class="col-12 col-lg-6 c g">
        <div class="card">
            <div class="card-body">
                <div class="form-group">
                  <h5 for="">العنوان</h5>
                  <input type="text"
                    class="form-control" v-model="title" placeholder="عنوان/اسم التعميم...">
                </div>
                <div class="form-group">
                  <h5 for="">متحوى التعميم <a href="javascript:;" @click="templates('asd433452')"><u><i class="fa fa-comment"></i> قوالب الرسائل</u></a></h5>
                  <textarea class="form-control asd433452" v-model="content" rows="5" placeholder="اكتب المحتوى هنا..."></textarea>
                </div>
                <div class="form-group">
                  <h5 for="">الرسالة التي تصل للمعلم <a href="javascript:;" @click="templates('asd43345')"><u><i class="fa fa-comment"></i> قوالب الرسائل</u></a></h5>
                  <textarea class="form-control asd43345" v-model="message" rows="5" placeholder="اكتب الرسالة هنا..."></textarea>
                </div>
                <div class="form-group">
                  <label for="">ارفاق ملف</label>
                  <input type="file"
                    class="form-control" id="ingredient_file" accept=".png,.jpeg,.jpg,.pdf,.docx,.doc,.xls,.xlsx" @change="uploadImage()">
                    <strong v-if="loading" id="helpId" class="form-text text-success">
                        <img :src="require('@/assets/images/loading.svg')" style="width: 20px;" alt=""> جاري الرفع...
                    </strong>
                </div>
                <div class="g">
                    <div class="border g">
                        <small>المتغيرات في الرسالة</small>
                        <br>
                        اسم المعلم: {name}
                        <br>
                        رابط التعميم: {link}
                    </div>
                </div>
            </div>
            <div class="card-footer" v-if="!saved">
                <div class="col-12 text-center g">
                    <button class="btn btn-success" v-if="!loading2" @click="save()">
                        حفظ وارسال الآن
                        <i class="fa fa-arrow-left"></i>
                    </button>
                    <button class="btn btn-success disabled" disabled v-if="loading2">
                        برجاء الانتظار...
                    </button>
                </div>
            </div>
            <div class="card-footer" v-if="saved">
                <div>
                    <div class="g">
                        اختيار المعلمين &nbsp; <a href="javascript:;" @click="selected = teachers"><i class="fa fa-check-square"></i> اختيار الكل</a>
                    </div>
                    <div style="width: 100%; border: solid 2px #333; padding: 5px; overflow-y: scroll; height: 150px;">
                        <div class="form-check" v-for="teacher in teachers" :key="teacher._id">
                        <label class="form-check-label">
                            <input type="checkbox" class="form-check-input" v-model="selected" :value="teacher">
                            {{ teacher.name }}
                        </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer" v-if="selected.length > 0">
                <div class="row">
                    <div class="col-12 col-lg-6 g">
                <b-dropdown style="width: 100%"
                    id="dropdown-1" dropup size="lg"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                >
                    <template #button-content>
                        <i class="fa fa-whatsapp"></i>
                        واتساب
                    </template>
                    <b-dropdown-item @click="save(); send('whatsapp')" style="border-bottom: solid 1px #ddd">
                        <span style="font-size: 18"><img :src="require('@/assets/images/whats-1.png')" style="width: 28px;">
                        واتساب تلقائي (الواتس الذكي)</span>
                    </b-dropdown-item>
                    <b-dropdown-item  @click="save(); send('wa')" style="border-bottom: solid 1px #ddd">
                        <span style="font-size: 18"><img :src="require('@/assets/images/whats-2.png')" style="width: 28px;">
                            اداة المتصفح المجانية</span>
                    </b-dropdown-item>
                    <b-dropdown-item  @click="save(); send('xwa')" style="border-bottom: solid 1px #ddd">
                        <span style="font-size: 18"><img :src="require('@/assets/images/whats-3.png')" style="width: 28px;">
                        الاداة المتطورة (الواتس المباشر) <i class="btn btn-danger" style="padding: 2px">جديد</i></span>
                    </b-dropdown-item>
                    <div class="text-center g">
                        <a href="/whats-methods" target="_blank">ما الفرق بينهم؟</a>
                    </div>
                </b-dropdown>
            </div>
            <div class="col-12 col-lg-6 g">
                <button class="btn btn-primary btn-block btn-lg"  @click="save(); send('sms')">
                    <i class="fa fa-mobile"></i>
                    SMS
                </button>
                <button class="btn btn-outline-primary mt-50 btn-block btn-lg"  @click="save(); send('push')">
                    <i class="fa fa-bell"></i>
                    إشعار الجوال
                </button>
            </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            message: `المعلم {name}
لديك تعميم جديد
رابط التعميم: {link}`,
            loading: false,
            loading2: false,
            file: null,
            user: JSON.parse(localStorage.getItem('user')),
            way: false,
            teachers: [],
            classrooms: [],
            q: null,
            selected: [],
            title: "",
            content: "",
            saved: null
        }
    },
    created(){
        if(!checkPer("teachers|mails")){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
        g.getStudents()
    },
    methods: {
        templates(x){
            $("#templates").click()
            $("#inserttemplateto").val(x)
        },
        getStudents(){
            var g = this;
            $.post(api + '/user/teachers/list', {
                jwt: this.user.jwt
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.teachers = r.response
                }
            }).fail(function(){
                g.loading = false;
            })
        },
        save(){
            var g = this;
            g.loading2 = true;
            if(g.saved){
                $.post(api + '/user/teachers/mails/update', {
                    id: g.saved,
                    jwt: this.user.jwt,
                    title: g.title,
                    content: g.content,
                    title: g.title,
                    file: g.file,
                    selected: g.selected.map(function(x){return x.number})
                }).then(function(r){
                    g.loading = false
                    if(r.status != 100){
                        alert(r.response)
                    }else{
                    }
                }).fail(function(){
                    g.loading = false;
                })
            }else{
                $.post(api + '/user/teachers/mails/create', {
                    jwt: this.user.jwt,
                    title: g.title,
                    content: g.content,
                    title: g.title,
                    file: g.file,
                    selected: g.selected.map(function(x){return x.number})
                }).then(function(r){
                    g.loading = false
                    if(r.status != 100){
                        alert(r.response)
                    }else{
                        g.saved = r.response
                    }
                }).fail(function(){
                    g.loading = false;
                })
            }
        },
        send(method){
            var g = this;
            var messages = [];
            g.selected.forEach(function(a){
                messages.push({
                    phones: [a.phone], to: "teachers",
                    message: g.message.replace("{name}", a.name).replace("{link}", `({https://s.tahdir.net/mail/${g.saved}/${a._id}})`)
                })
            })
            if(g.file && messages[0]?.message?.includes("({")){
                $.post(api + '/user/general/short-links', {
                    jwt: this.user.jwt,
                    arr: JSON.stringify(messages),
                }).then(function(rx){
                    if(method == 'wa'){
                        $("#sendmodalwaarray").val(JSON.stringify(rx.response))
                        $("#sendmodalwatype").val("students")
                        $("#sendWAModal").click()
                    }else{
                        if(!confirm(`متأكد من ارسال ${messages.length} رسالة؟`)){return false;}
                        $.post(api + '/user/messages/send-arr', {
                            jwt: g.user.jwt,
                            arr: JSON.stringify(rx.response),
                            method: method,
                            type: "teachers"
                        }).then(function(r){
                            g.loaded = true;
                            if(r.status != 100){
                                alert(r.response, 200)
                            }else{
                                alert("تم الارسال بنجاح٫ يمكنك تصفح ارشيف الرسائل", 100)
                            }
                        }).fail(function(){
                            alert("حدث خطأ", 200)
                        })
                    }
                }).fail(function(){
                        alert("حدث خطأ.", 200)
                    })
            }else{
                 $.post(api + '/user/general/short-links', {
                    jwt: this.user.jwt,
                    arr: JSON.stringify(messages),
                }).then(function(rx){
                if(method == 'wa'){
                    $("#sendmodalwaarray").val(JSON.stringify(messages))
                    $("#sendmodalwatype").val("students")
                    $("#sendWAModal").click()
                }else{
                    $.post(api + '/user/messages/send-arr', {
                        jwt: g.user.jwt,
                        arr: JSON.stringify(rx.response),
                        method: method,
                        type: "teachers"
                    }).then(function(r){
                        g.loaded = true;
                        if(r.status != 100){
                            alert(r.response, 200)
                        }else{
                            alert("تم الارسال بنجاح٫ يمكنك تصفح ارشيف الرسائل", 100)
                        }
                    }).fail(function(){
                        alert("حدث خطأ", 200)
                    })
                }
            })
            }
        },
        uploadImage(){
            var g = this;
            g.loading = true;
            var Upload = function (file) {
                this.file = file;
            };

            Upload.prototype.getType = function () {
                return this.file.type;
            };
            Upload.prototype.getSize = function () {
                return this.file.size;
            };
            Upload.prototype.getName = function () {
                return this.file.name;
            };
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();

                // add assoc key values, this will be posts values
                formData.append("file", this.file, this.getName());
                formData.append("jwt", g.user.jwt);

                $.ajax({
                type: "POST",
                url: api + '/user/general/upload',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                    myXhr.upload.addEventListener(
                        "progress",
                        that.progressHandling,
                        false
                    );
                    }
                    return myXhr;
                },
                success: function (data) {
                    g.loading = false;
                    // your callback here
                    if(data.status != 100){
                        alert("هذا الملف غير غير", 200)
                        return;
                    }
                    g.file = data.response
                },
                error: function (error) {
                    // handle error
                    alert("حدث خطأ");
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000,
                });
            };
            var file = $("#ingredient_file")[0].files[0];
            var upload = new Upload(file);
            upload.doUpload();
        }
    }
}
</script>

<style>

</style>